import { useTranslation } from "react-i18next";
import harmonaiLogo from "@/assets/harmonyai-logo.svg";

/**
 * Post-login gate karar verirken gösterilen markalı splash.
 * Boş beyaz div yerine kullanılır — gate artık yalnızca ilk (önbelleksiz)
 * açılışta beklediği için normalde bir anlık görünür.
 */
export function AppGateSplash() {
  const { t } = useTranslation();
  return (
    <div className="flex h-screen w-screen flex-col items-center justify-center gap-4 bg-bg-primary">
      <img
        src={harmonaiLogo}
        alt="HarmonyAI"
        className="h-14 w-14 animate-pulse"
      />
      <p className="animate-pulse text-sm font-medium text-text-secondary">
        {t("common.loading", { defaultValue: "Yükleniyor..." })}
      </p>
    </div>
  );
}
